import React, { FC } from 'react'
import { ProductPrice } from '../ProductPrice/ProductPrice'

export const FromPrice: FC<{
  priceCentAmount: number
  currencyCode: string
  fractionDigits: number
  minimumQuantity?: number
  fullPriceCentAmount?: number
  discountedPercentage?: number | null
  showFromPrice?: boolean
  color?: string
}> = ({
  priceCentAmount,
  currencyCode,
  fractionDigits,
  minimumQuantity,
  fullPriceCentAmount,
  discountedPercentage,
  showFromPrice = true,
  color,
}) => {
  return (
    <ProductPrice
      priceCentAmount={priceCentAmount}
      currencyCode={currencyCode}
      fractionDigits={fractionDigits}
      minimumQuantity={minimumQuantity}
      fullPriceCentAmount={fullPriceCentAmount}
      discountedPercentage={discountedPercentage}
      showFromPrice={showFromPrice}
      color={color}
    />
  )
}
